export const ReportGenerationHelpText = {
  title: "How to Use This Tool",
  content: {
    description: "This tool allows you to search for specific use cases. Follow these steps to use the tool effectively:",
    steps: [
      "Select a prompt from the Prompt Manager or enter your query directly.",
      "You can save new generated themes as featured for quick access in the Use cases Library.",
      "Click the \"Search Use cases\" button to initiate the search.",
      "While the search is in progress, you can view the use cases and the thoughts as they are being processed.",
      "Once the search is complete, you will be forwarded to the Use cases Library page to view all the results for the generated theme.",
      "The theme will be generated automatically based on the prompt. if a theme already exists, it will be used instead of generating a new one."
    ],
    footer: "If you encounter any issues, please ensure all required fields are filled out and try again."
  }
}; 